import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from "@angular/core";
import { S25IconComponent } from "../modules/s25-icon/s25.icon.component";
import { TypeManagerDecorator } from "../main/type.map.service";

@TypeManagerDecorator("s25-ng-icon-button")
@Component({
    selector: "s25-ng-icon-button",
    host: {
        "[class.rounded]": "round()",
    },
    template: `
        <button
            (click)="clicked.emit($event)"
            class="c-iconButton"
            [disabled]="disabled()"
            [title]="disabled() ? disabledReason() : ''"
            [attr.aria-label]="ariaLabel() || undefined"
            [attr.aria-expanded]="ariaExpanded()"
            [attr.aria-controls]="ariaControls()"
            [attr.tabindex]="tabIndex()"
        >
            <s25-ng-icon
                [type]="type"
                [ariaLabel]="!!ariaLabel() || ariaLabel() === false ? false : undefined"
                [size]="size"
                [autoDarkMode]="autoDarkMode"
                [rotating]="rotating"
            />
        </button>
    `,
    styles: `
        .c-iconButton {
            background-color: unset;
            border-radius: var(--border-radius);
            border: none;
            padding: 0;
            color: var(--icon-color, var(--color--link-text));
            transition:
                color var(--transition-medium),
                background-color var(--transition-medium),
                box-shadow var(--transition-medium);

            &:disabled {
                color: var(--color--text-muted);
            }
            &:not(:disabled) {
                cursor: pointer;

                &:hover {
                    background-color: var(--color--primary-flat-bg);
                }
                &:focus,
                &:focus-visible {
                    box-shadow: var(--shadow--inner-focus);
                    outline: none;
                }
                &:active {
                    background-color: var(--color--primary-flat-active-bg);
                    color: var(--color--primary-flat-active-fg);
                    box-shadow: var(--shadow--inner-focus-active), var(--shadow--active);
                }
            }
        }
        :host.rounded .c-iconButton {
            padding: 0.25em;
            border-radius: 50%;
            aspect-ratio: 1/1;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
    imports: [S25IconComponent],
})
export class S25IconButtonComponent extends S25IconComponent {
    readonly disabled = input(false);
    readonly disabledReason = input("");
    readonly round = input(false);
    readonly ariaExpanded = input<boolean>();
    readonly ariaControls = input<string>();
    readonly tabIndex = input<number | undefined>(undefined);

    readonly clicked = output<MouseEvent>();
}
